<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-load-balancing`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 5a8 8 0 015.816 13.493l.087.118.079.126 5.438 9.419a8 8 0 11-6.021 10.345H18.6a8 8 0 11-6.021-10.345l5.438-9.42a2.18 2.18 0 01.166-.244A8 8 0 0124 5zM11 32a4 4 0 100 8 4 4 0 000-8zm26 0a4 4 0 100 8 4 4 0 000-8zM21.482 20.737l-5.295 9.172A7.992 7.992 0 0118.86 34.5h10.28a7.992 7.992 0 012.673-4.591l-5.295-9.172a2.078 2.078 0 01-.065-.121A7.96 7.96 0 0124 21a7.993 7.993 0 01-2.454-.384l-.064.12zM24 9a4 4 0 100 8 4 4 0 000-8z"/></svg>
</template>
<script>

export default {
  name: 'IconLoadBalancing',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
